import { create } from "zustand";

type PreviewOverrides = {
  activeTabIndex?: number;
  isClaimed?: boolean;
  isTamperSealed?: boolean;
};

type PreviewState = {
  overrides: PreviewOverrides;
  updateOverrides: (overrides: PreviewOverrides) => void;
};

export const usePreviewStore = create<PreviewState>((set) => ({
  overrides: {
    activeTabIndex: 0,
    isClaimed: true,
    isTamperSealed: false,
  },
  updateOverrides: (overrides) => {
    set((state) => ({ overrides: { ...state.overrides, ...overrides } }));
  },
}));
